/**
 * /bmr-tracking is retired (EXV-027): BMR Details → Ongoing carries its filters and Terminate, and Live Batch Monitor
 * stays the supervisor's live view. Old links land on the Ongoing list; a ?batch= link keeps its batch as the search.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function BmrTrackingRedirect() {
  const { search } = useLocation();
  const batch = (new URLSearchParams(search).get('batch') || '').trim();
  const next = new URLSearchParams({ tab: 'ongoing', ...(batch ? { batch } : {}) });
  return <Navigate to={`/batches?${next.toString()}`} replace />;
}
